import { createFileRoute, Outlet } from '@tanstack/react-router'

function OrdersLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/_authed/_user/orders')({
  component: OrdersLayout,
  beforeLoad: () => ({
    getTitle: () => 'Orders',
  }),
})
